import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SensorFailure, FailureAuditTypeAhead } from '../../../common/model';
import { GrowlService, WorkflowService, AuthService, CacheService } from '../../../common/service';
import { Permission } from '../../../common/enum';
import { catchError, tap } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'sensor-failure-manually-add',
    templateUrl: './sensor-failure-manually-add.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, FormsModule, ReactiveFormsModule, InputTextModule,  AutoCompleteModule, ButtonDirective, TooltipModule, DatePickerModule]
})
export class SensorFailureManualAddComponent implements OnInit {
  @Input() visible: boolean;
  @Input() sensorFailure: SensorFailure;
  @Input() submitted: boolean;
  @Output() saveEvent: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();
  Permission = Permission;
  editForm: FormGroup;
  pod_serial_number: FormControl;
  sensor_serial_number: FormControl;
  replacement_sensor_serial: FormControl;
  shipped: FormControl;
  not_required: FormControl;
  not_needed: FormControl;
  failure_date: FormControl;
  notes: FormControl;

  typeAheadSuggestions: FailureAuditTypeAhead[];
  typeAheadFiltered: FailureAuditTypeAhead[] = [];
  noteSelected: any;

  constructor(
     @Inject(AuthService) public authService: AuthService,
    private workflowService: WorkflowService,
    @Inject(GrowlService) public growlService: GrowlService,
    @Inject(CacheService) public cacheService: CacheService) { }

  ngOnInit() {
    this.cacheService.SetLocal('login-lastChoice', 'workflow/fails');
    this.submitted = false;
    this.sensorFailure = new SensorFailure();

    this.editForm = new FormGroup({
      pod_serial_number: new FormControl(this.sensorFailure.pod_serial_number, [Validators.maxLength(25)]),
      sensor_serial_number: new FormControl(this.sensorFailure.sensor_serial_number, [Validators.pattern('(?=.*[0-9]).{9,}')]/*[Validators.pattern('^[0-9]*$'), Validators.maxLength(9)]*/),
      replacement_sensor_serial: new FormControl(this.sensorFailure.replacement_sensor_serial, [Validators.maxLength(25)]),
      shipped: new FormControl(this.sensorFailure.shipped),
      not_required: new FormControl(this.sensorFailure.not_required),
      not_needed: new FormControl(this.not_needed),
      failure_date: new FormControl(this.sensorFailure.failure_date),
      notes: new FormControl(this.sensorFailure.notes)
    });
  }

  autoComplete(event) {
    this.typeAheadFiltered = [];
    for (let i = 0; i < this.typeAheadSuggestions.length; i++) {
      const typeAhead = this.typeAheadSuggestions[i];
      if (typeAhead.notes.toLowerCase().startsWith(event.query.toLowerCase()) === true) {
        this.typeAheadFiltered.push(typeAhead);
      }
    }
  }

  exit() {
    this.cancelEvent.emit(null);
    this.sensorFailure = new SensorFailure();
    this.submitted = false;
  }

  loadLists() {
    this.workflowService.getSensorNotes().pipe(tap((data) => {
      this.typeAheadSuggestions = data;
    }), catchError((error) => {
      this.growlService.error(error);
      return error;
    })).subscribe();
  }

  reported() {
    this.submitted = true;
    // if (!isNullOrUndefined(this.sensorFailure.replacement_sensor_serial)) {
      this.growlService.error(`Do not enter a replacement sensor if not confirmed!<br /><br />Please correct.`);
      this.submitted = false;
      return;
    // }
    if (this.editForm.valid) {
      if (this.noteSelected !== undefined) {
        // if (isString(this.noteSelected)) {
        //   this.sensorFailure.notes = this.noteSelected;
        // } else {
        //   this.sensorFailure.notes = this.noteSelected.notes;
        // }
      }
      this.sensorFailure.shipped = false;
      this.sensorFailure.not_needed = false;
      this.sensorFailure.not_required = false;
      this.sensorFailure.fail_confirmed = false;
      this.workflowService.postManuallyFailSensor(this.sensorFailure).pipe(tap((r) => {
        this.submitted = false;
        this.saveEvent.emit(null);
        this.growlService.success(`Successfully added`);

        this.cancelEvent.emit(null);
      }), catchError((error) => {
        this.submitted = false;
        this.growlService.error(`Pod ${this.sensorFailure.pod_serial_number}, Sensor ${this.sensorFailure.sensor_serial_number} : ${error};`);
        return error;
      })).subscribe();
    } else {
      this.submitted = false;
      this.growlService.error(`Please correct.`);
    }
  }

  confirm() {
    this.submitted = true;
    if (this.editForm.valid) {
      if (this.noteSelected !== undefined) {
        // if (isString(this.noteSelected)) {
        //   this.sensorFailure.notes = this.noteSelected;
        // } else {
        //   this.sensorFailure.notes = this.noteSelected.notes;
        // }
      }

      // this.sensorFailure.shipped = (!isNullOrUndefined(this.sensorFailure.replacement_sensor_serial));
      this.sensorFailure.not_needed = false;
      this.sensorFailure.not_required = false;
      this.sensorFailure.fail_confirmed = true;

      this.workflowService.postManuallyFailSensor(this.sensorFailure).pipe(tap((r) => {
        this.submitted = false;
        this.saveEvent.emit(null);
        this.growlService.success(`Successfully added`);
      }), catchError((error) => {
        this.submitted = false;
        this.growlService.error(`Pod ${this.sensorFailure.pod_serial_number}, Sensor ${this.sensorFailure.sensor_serial_number} : ${error};`);
        return error;
      })).subscribe();
    } else {
      this.submitted = false;
      this.growlService.error(`Please correct.`);
    }
  }

  has(requiredPermissions: Permission | Permission[]) {
    return this.authService.hasPermission(requiredPermissions);
  }
}
